import React, { Component } from 'react';
import ButtonMailto from '../components/MailButton.js'

import { Fade } from "react-awesome-reveal";

class Social extends Component {
    render() {
        return (
          <Fade>
            <div class="consec" style={{"border-bottom":"none"}} id="contacts">
              <h4> Contact </h4>
              <div class="socialdiv" style={{"display":"flex", "justify-content":"space-around"}}>
                  <div className="social_icon">
                    <a href={'https://github.com/haozheee'} className="contactlink">GitHub</a>
                  </div>
                  <div className="social_icon">
                    <a href={'https://www.linkedin.com/in/haozhe-zhou-8b6882170/'} className="contactlink">LinkedIn</a>
                  </div>
                  <div className="social_icon">
                    <ButtonMailto label="E-Mail" mailto="mailto:zhou929@purdue.edu"/>
                  </div>
              </div>
            </div>
            </Fade>
            )
        }
    }

export default Social
